import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Constants } from './constants';

@Injectable({
  providedIn: 'root'
})
export class AuthenticationService {
  serviceURL = "/v1/Authorization/";

  constructor(private http: HttpClient) { }

  register(fullname: string, email: string, screenname: string, password: string) {

    const url = Constants.baseURL + this.serviceURL + 'Register';
    let encodedPassword = window.btoa(unescape(encodeURIComponent(password)));

    return this.http.post(url,
      {
        "FullName": fullname,
        "ScreenName": screenname,
        "Password": encodedPassword,
        "Email": email
      }
    );
  }

  login(email: string, password: string) {

    const url = Constants.baseURL + this.serviceURL + 'Login';
    let encodedPassword = window.btoa(unescape(encodeURIComponent(password)));

    return this.http.post(url,
      {
        "email": email,
        "password": encodedPassword
      }
    );
  }

  sendResetPasswordMail(email: string) {
    const url = Constants.baseURL + this.serviceURL + 'SendResetPasswordMail?email=' + email;
    return this.http.get(url);
  }

  resetPassword(token: string, password: string) {

    const url = Constants.baseURL + this.serviceURL + 'ResetPassword';
    let encodedPassword = window.btoa(unescape(encodeURIComponent(password)));

    return this.http.post(url,
      {
        "PasswordResetToken": token,
        "Password": encodedPassword
      }
    );
  }
}
